import React, { useState } from "react"
import { css } from '../../page-helpers/aphrodite-export';
import FormHandler from '../../page-helpers/contact-formhandler';
import {isMobile} from 'react-device-detect';
import {MobileStyles, DesktopStyles} from '../../styles/contactus';

const btnText = 'SEND MESSAGE';

export default () => {
    const ContactStyles = isMobile ? MobileStyles : DesktopStyles;
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');
    const [statusInfo, setStatusInfo] = useState(btnText);

    const resetBtn = function(time) {
        setTimeout(function() {
            setStatusInfo(btnText);
        }, time ? time : 5000);
    };

    const submitContactInfo = function() {
        console.log(name, email, phone, message);
        var data = {name: name, email: email, phone: phone, message: message};

        if (FormHandler.validateForm(data)) {
            setStatusInfo('Submitting Info ... ');

            FormHandler.submitForm(data)
            .then(function() {
                setName('');
                setEmail('');
                setPhone('');
                setMessage('');
                setStatusInfo('Done');

                resetBtn(8000);
            }).catch(function(err) {
                setStatusInfo('Error');

                resetBtn(3000);
            });
        } else {
            setStatusInfo('Invalid data to submit');

            resetBtn(2000);
        }
    };

    return (
        <div className={css(ContactStyles.formSecContentsForm)}>
            <input type='text' placeholder='name' value={name}
                onChange={(e) => {setName(e.target.value)}}
                className={css(ContactStyles.formSecContentsFormInput)}  />
            <input type='text' placeholder='phone number' value={phone}
                onChange={(e) => {setPhone(e.target.value)}}
                className={css(ContactStyles.formSecContentsFormInput)} />
            <input type='text' placeholder='e-mail' value={email}
                onChange={(e) => {setEmail(e.target.value)}}
                className={css(ContactStyles.formSecContentsFormInput)} />
            <textarea type='textarea' placeholder='your message' value={message}
                onChange={(e) => {setMessage(e.target.value)}}
                className={css(ContactStyles.formSecContentsFormInput)} rows="4" />

            <div className={css(ContactStyles.formSecContentsFormBtn)}
                onClick={statusInfo === btnText ? submitContactInfo : null}>{statusInfo}</div>
        </div>
    );
};